import React from 'react';
import { StatelessAccordion, StatelessAccordionProps } from 'baseui/accordion';
import { IDummyProps } from './types';
import { FocusManager, ArrowDirection } from '../../Lib/FocusManager';

export const StatelessView = React.forwardRef((props: IDummyProps & StatelessAccordionProps, ref: any) => {
	const { children, accordion = false, ...rest } = props;

	let itemRefs: any[] = [];

	const handleKeyDown = (e: any, dataKey: number) => {
		if (props.disabled) {
			return;
		}

		const findButtonGroup: any = (target: any, loop: number) => {
			const limitParents = 3;
			if (loop <= limitParents) {
				if (target.parentElement.getAttribute('data-epo') == `epo-accordion`) {
					return target.parentElement;
				} else {
					return findButtonGroup(target.parentElement, loop + 1);
				}
			}
			return null;
		};

		let parent = findButtonGroup(e.target, 0);

		const _itemRefs = itemRefs;

		const HOME = 36;
		const END = 35;
		const ARROW_UP = 38;
		const ARROW_DOWN = 40;

		const _children: any = children;

		if (e.keyCode === HOME) {
			e.preventDefault();
			const newPosition = 0;
			const focussableElements = '[data-key="' + newPosition + '"] [data-subcomponent="panel-header"]';
			parent.querySelector(focussableElements).focus();
		}
		if (e.keyCode === END) {
			e.preventDefault();
			const newPosition = _children?.length - 1;
			const focussableElements = '[data-key="' + newPosition + '"] [data-subcomponent="panel-header"]';
			parent.querySelector(focussableElements).focus();
		}
		if (e.keyCode === ARROW_UP) {
			e.preventDefault();
			const newPosition = dataKey == 0 ? _children?.length - 1 : +dataKey - 1;
			const focussableElements = '[data-key="' + newPosition + '"] [data-subcomponent="panel-header"]';
			parent.querySelector(focussableElements).focus();
		}
		if (e.keyCode === ARROW_DOWN) {
			e.preventDefault();
			const newPosition = (+dataKey + 1) % _children?.length;
			const focussableElements = '[data-key="' + newPosition + '"] [data-subcomponent="panel-header"]';
			parent.querySelector(focussableElements).focus();
		}
	};

	const getItems = () => {
		return React.Children.map(children, (child: any, index) => {
			if (!child) return;

			const itemRef = React.useRef<any>();
			itemRefs.push(itemRef);

			// If there is no key provided use the panel order as a default key
			const key = child.key || String(index);

			const props = {
				key,
				ref: itemRef,
				'data-key': index,
				onKeyDown: (e: any) => handleKeyDown(e, index),
				...child.props,
			};
			return React.cloneElement(child, props);
		});
	};

	return (
		<div ref={ref} data-epo="epo-accordion">
			<StatelessAccordion {...rest} /* TODO: test failing ref={myRef} */>{getItems()}</StatelessAccordion>
		</div>
	);
});
